import request from '@/utils/request'

let TeacherApi = {

  /*名师列表*/
  list(data) {
    return request._post('/shop/plus.teacher.Index/index', data);
},
getSchool(data) {
    return request._post('/shop/plus.teacher.Index/getSchool', data);
},
/*添加名师*/
add(data) {
    return request._post('/shop/plus.teacher.Index/add', data);
},
/*修改名师*/
edit(data) {
    return request._post('/shop/plus.teacher.Index/edit', data);
},
/*删除名师*/
del(data) {
    return request._post('/shop/plus.teacher.Index/del', data);
},
/*名师详情*/
detail(data) {
  return request._post('/shop/plus.teacher.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.teacher.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.teacher.Setting/getSetting', data, errorback);
    },
}
export default TeacherApi;



// WEBPACK FOOTER //
// ./src/api/teacher.js